import { nonNullable } from '@/shared/utils/typeAssertions'
import { inject, provide } from 'vue'

import type { InjectionKey, Ref } from 'vue'

type ProjectContext = {
  projectId: Ref<string>
  workspaceId: Ref<string>
}
export const PROJECT_CONTEXT_KEY: InjectionKey<ProjectContext> = Symbol('project')

export const provideProjectContext = (context: ProjectContext) =>
  provide(PROJECT_CONTEXT_KEY, context)

/**
 * Injects assumed to be provided project context.
 *
 * Provides id data for the project that is being worked with within the current component hierarchy.
 */
export const useProjectContext = () => {
  const projectContext = inject(PROJECT_CONTEXT_KEY)
  return nonNullable(projectContext, 'Project context was not provided')
}
